import Vue from 'vue'
import store from '@/store'
import Router from 'vue-router'
const Index = ()=>import('@/components/Index')
const Article = ()=>import('@/components/article/Index')
const Message = ()=>import('@/components/message/Index')
const Detail = ()=>import('@/components/article/Detail')
const Link = ()=>import('@/components/link/Index')
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
    },
    {
      path: '/articles/detail',
      name: 'Detail',
      component: Detail,
    },
    {
      path: '/articles',
      name: 'ArticleCategory',
      component: Article,
    },
    {
      path: '/message',
      name: 'Message',
      component: Message,
    },
    {
      path: '/link',
      name: 'Link',
      component: Link,
    },
  
  ],
  scrollBehavior(to, from, savedPosition) {
    // 若有保存的滚动位置（如浏览器后退），可恢复；否则回到顶部
    // 这里统一回到顶部
    return { x: 0, y: 0 }
  },
});

router.beforeEach(async (to,from,next)=>{
  console.dir("to.query:"+to.query)
  const token = to.query.token;
  console.dir("token:"+token)
  //删除url上的token和expireSeconds，不保留在地址栏
  if(token){
    console.dir("设置token")
    store.commit('user/SET_TOKEN',token);
    console.dir("token0:"+store.state.user.token)
    const newQuery = {...to.query};
    delete newQuery.token;
    delete newQuery.expireSeconds
    try{
      console.dir("开始发起接口调用")
      await store.dispatch('user/getUserInfo')
      next({ path: to.path, query: newQuery, replace: true })
    }catch(e){
      store.commit('user/CLEAR_USER')
      next({path:'/'})
    }
  }else{
    // 页面刷新场景：有token但是userInfo为空，拉取信息
    console.dir("token:"+store.state.user.token)
    console.dir("nickname"+store.state.user.userInfo.nickname)
    if (store.state.user.token && !store.state.user.userInfo.nickname) {
      try {
        await store.dispatch('user/getUserInfo')
      } catch (e) {
        store.commit('user/CLEAR_USER')
      }
    }
    next()
  }
})

export default router






// WEBPACK FOOTER //
// ./src/router/index.js